import React from "react";

function DashboardAdmin() {
  return (
    <div className="container mt-5">
      <h2>5Party Dashboard</h2>
      <p>Welcome, 5Party</p>
    </div>
  );
}

export default DashboardAdmin;